import { Space } from '@flatfile/api-internal/api'
import { Text, Tooltip, TooltipContent, TooltipTrigger } from '@flatfile/baseline'

interface UserInfo {
  companyId?: string
  companyName?: string
  name?: string
  userId?: string
}

interface UserInfoListProps {
  userInfo?: UserInfo
}

export const badgeColors = ['pink', 'purple', 'blue', 'green', 'orange', 'amber', 'gray']

export const UserInfoGuest = ({ space }: { space: Space }) => {
  if (!space) return <></>
  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Text className='text-sm truncate'>{space.metadata?.userInfo?.name}</Text>
        </TooltipTrigger>
        <TooltipContent className='flex items-center px-2 py-1'>
          <UserInfoList userInfo={space.metadata?.userInfo} />
        </TooltipContent>
      </Tooltip>
      {space.metadata?.userInfo?.companyName && (
        <div
          className='inline-flex items-center border px-1.5 py-0.5 text-xxs rounded-sm mr-1 truncate align-middle my-auto'
          style={{
            backgroundColor: `var(--tokens-light-color-${badgeColors[1]}-3)`,
            color: `var(--tokens-light-color-${badgeColors[1]}-9)`,
            borderColor: `var(--tokens-light-color-${badgeColors[1]}-6)`,
            verticalAlign: 'middle',
            lineHeight: 1,
          }}
        >
          {space.metadata?.userInfo?.companyName}
        </div>
      )}
    </>
  )
}

const UserInfoList: React.FC<UserInfoListProps> = ({ userInfo }) => {
  const infoKeys = [
    { key: 'userId', label: 'User ID' },
    { key: 'name', label: 'Name' },
    { key: 'companyId', label: 'Company ID' },
    { key: 'companyName', label: 'Company Name' },
  ]

  const listItems = infoKeys
    .filter((info) => userInfo?.[info.key as keyof UserInfo]) // Safely access userInfo properties
    .map((info) => (
      <div key={info.key} className='mb-2'>
        <Text className='font-bold text-sm'>{info.label}</Text>
        <Text className='text-sm'>{userInfo![info.key as keyof UserInfo]}</Text>
      </div>
    ))

  return listItems.length > 0 ? <>{listItems}</> : <Text className='text-sm'>No additional information available.</Text>
}
